
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(29|78)1$/.test(chunkId);
},
rootOutputDir: "",

    };
}
